import { ActiveParticipantService } from '@app/services/participants/active-participant.service';
import {
	Component,
	OnInit,
	OnDestroy,
	Output,
	EventEmitter,
	ViewChild,
	Input, ElementRef,
} from '@angular/core';
import { ProtectedPrivacyService } from '@app/services/ui/protected-privacy.service';
import { ProjectService } from '@app/services/project/project.service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { participantPages } from '@app/pages/participant/participants.routes';
import { ParticipantService } from '@app/services/participants/participant.service';
import { TParticipantSearchResult } from '@app/services/participants/interfaces';

export interface SearchResult {
	infoShort: string
	infoMain: string
	infoLong: string
	id: string
}

@Component({
	selector: 'app-search',
	templateUrl: './search.component.html',
	styleUrls: ['./search.component.scss'],
})
export class TopbarSearchComponent implements OnInit, OnDestroy {

	private autofocusedEl: ElementRef<HTMLInputElement> = null;
	@ViewChild('autofocused', { static: false })
	set autofocused(element: ElementRef<HTMLInputElement>) {
		if (!element) return;

		this.autofocusedEl = element;
		if (this.hasAutofocus) {
			setTimeout(() => {
				element.nativeElement.focus();
			}, 0);
		}
	}

	protectedPrivacy = false;
	searchText = '';

	/** Anzeigen im Suchformular */
	useExtendedSearch = true;
	tooManyResults = false;

	@Output() searchResults = new EventEmitter<TParticipantSearchResult>();
	@Output() isLoading = new EventEmitter<boolean>();

	private subscription = new Subscription();
	private hasAutofocus = false;
	@Input()
	set autofocus(auto: boolean) {
		this.hasAutofocus = auto;
		if (auto) {
			this.autofocusedEl?.nativeElement.focus();
		}
	}

	constructor(
		private readonly activeParticipantService: ActiveParticipantService,
		private readonly privacyService: ProtectedPrivacyService,
		private readonly store: Store<unknown>,
		private readonly projectService: ProjectService,
		private readonly participantService: ParticipantService,
		public readonly router: Router,
	) {

	}

	ngOnInit(): void {
		this.subscription.add(this.privacyService.toggleChange$()
			.subscribe(status => this.changePrivacy(status) ));
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	private changePrivacy(status: boolean): void {
		this.resetSearchResults();

		this.protectedPrivacy = status;
	}

	private resetSearchResults(): void {
		this.tooManyResults = false;
		this.searchText = null;
	}

	livesearch(searchString: string): void {
		this.searchText = searchString;
		this.doLiveSearch().catch(console.warn);
	}

	private async doLiveSearch() {
		if (this.protectedPrivacy) {
			return;
		}

		await this.doSearch();
	}

	public async doSearch(): Promise<void> {
		this.isLoading.emit(true);

		const info: TParticipantSearchResult = await this.participantService.searchMetaByString(this.searchText, this.protectedPrivacy);

		this.tooManyResults = info.status === 'unspecific';

		this.searchResults.emit(info);
	}

	openSearchResult(searchResult: SearchResult): void {
		this.activeParticipantService.activeParticipant = { id: searchResult.id };
		this.router.navigate([participantPages.stammDaten.base()]).catch(console.error);
	}

	toggleExtendedSearch(): void {
		this.useExtendedSearch = !this.useExtendedSearch;
		this.doLiveSearch();
	}
}
